import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-component',
  templateUrl: './why-component.component.html',
  styleUrls: ['./why-component.component.scss']
})
export class WhyComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
